<!--
 * @Descripttion: 中海贵阳定制tabbar 底部默认都选中红色
 * @version: 
 * @Author: jing
 * @Date: 2020-09-10 20:14:58
 * @LastEditors: jing
 * @LastEditTime: 2020-12-09 16:09:23
-->
<template>
  <div class="tabbar12">
    <div
      v-for="item in evenNavData"
      class="tabbar_item"
      @click="clickItem(item)"
      :class="item.class"
      :style="item.style"
      :key="item.name"
    >
      <div class="tabbar_icon">
        <img :src="item.ico" />
      </div>
      <span class="tabbar_text">{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
// import createimg from "@/utils/createimg";
export default {
  components: {},
  props: {
    seleIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      myw: "20%",
      //底部导航
      navData: [
        {
          name: "首页",
          pagename: "home",
          click: "clickHome",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/home.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/home.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/home@checked.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false
        },
        {
          name: "项目介绍",
          pagename: "project",
          click: "clickProject",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/project.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/project.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/project@checked.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false
        },
        {
          name: "区位介绍",
          pagename: "location",
          click: "clickLocation",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/location.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/location.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/location@checked.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false
        },
        {
          name: "户型介绍",
          pagename: "layout",
          click: "clickLayout",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/housetype.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/housetype.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/housetype@checked.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false
        },
        {
          name: "房贷计算器",
          pagename: "calculator",
          click: "clickCalculator",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/calculator.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/calculator.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar12/v2/calculator@checked.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false
        }
      ],
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isShowHdkShare: false, //是否显示小程序分享
      isShowShareGuide: false, //是否显示网页分享
      isShowSaveAddressList: false, //是否显示存通讯录
      imgUrlCardPoster: ""
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ]),
    evenNavData: function() {
      return this.navData.filter(function(item, i) {
        return item.isHide != true;
      });
    }
  },
  methods: {
    clickItem(item) {
      console.log(item);
      // this[item.click]();
      this.activeItem(item);
    },
    // clickHome() {
    //   console.log("首页");
    //   this.seleIndex = 0;
    // },
    // clickProject() {
    //   console.log("项目介绍");
    // },
    // clickLocation() {
    //   console.log("区位介绍");
    // },
    // clickLayout() {
    //   console.log("户型介绍");
    // },
    // clickCalculator() {
    //   console.log("房贷计算器");
    // },
    // 激活按钮
    activeItem(item) {
      if (item.isActive == true) {
        return;
      }

      this.navData.forEach(element => {
        if (item.pagename == element.pagename) {
          element.ico = element.yes;
          element.isActive = true;
        } else {
          element.ico = element.no;
          element.isActive = false;
        }
      });
      // console.log(item.pagename);
      if (item.pagename == this.$route.name) {
        return;
      }
      // if (item.pagename == "calculator") {
      //   //房贷计算器
      //   let link = `${location.protocol}//${
      //     location.host
      //   }/activities/housing-loan/index.html`;
      //   util.openOtherLink(link);
      // } else if (item.pagename == "project") {
      //   // 项目介绍
      //   window.location.href = `http://gyzhys.celebpalace.com/qc-webapp/xcdm/rd/http%3A%2F%2Fgyzhys.abotz.com%2Fh5%2Ftp1.html%3Fid%3D178822%26psn%3D1571c8f27c4f4931b36002127ca70b10&t=1599818463017`;
      // } else if (item.pagename == "location") {
      //   // 区位介绍
      //   window.location.href = `http://gyzhys.celebpalace.com/qc-webapp/xcdm/rd/http%3A%2F%2Fgyzhys.abotz.com%2Fh5%2Ft1.html%3Fid%3D178821%26psn%3D9ea1ea83c50f451192da5960632feb5c&t=1599818345217`;
      // } else {
      this.$router.push(
        `/vcard3/${item.pagename}?entry=${this.$route.query.entry}&id=${
          this.$route.query.id
        }&psn=${this.$route.query.psn}&saleropenid=${
          this.$route.query.saleropenid
        }&backhome=home&t9id=${this.$route.query.t9id}&t9psn=${
          this.$route.query.t9psn
        }`
      );
      // }
    }
  },
  created() {
    console.log("this.navData[this.seleIndex]", this.seleIndex);
    this.navData[this.seleIndex].ico = this.navData[this.seleIndex].yes;
    this.navData[this.seleIndex].isActive = true;
  },
  mounted() {
    // if(seleIndex == 0){
    // }
    // this.activeItem({ pagename: this.$route.name });
  }
};
</script>
<style lang="css" scoped>
/* 底部导航 */
.tabbar12 {
  width: 100%;
  height: 50px;
  background: #fff;
  /* background: #f5af19; */
  /* background: linear-gradient(to right, #f5af19, #f12711); */
  /* background: linear-gradient(to right, #4CB8E9, #007DA6); */
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12;
  border-top: 1px solid #c6c6c6;
}

.tabbar_item {
  text-align: center;
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  flex-direction: column;
  width: 25%;
}

.tabbar_icon {
}

.tabbar_icon > img {
  width: 22px;
  height: 22px;
}

.tabbar_text {
  padding-top: 5px;
  display: inline-block;
  font-size: 12px;
}
.tabbar_item_chat {
}
.tabbar_item_chat img {
  width: 60px;
  height: 60px;
  margin-top: -30px;
}
</style>
